import {simpleAction} from "../../utils";
import * as TYPES from "./types";

/**
 * Create Sku
 * @type {function(type: string): {type: string, payload: any}}
 */
export const documentCreateRequest = simpleAction(TYPES.DOCUMENT_CREATE_REQUEST);

/**
 * Create Sku Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const documentCreateSuccess = simpleAction(TYPES.DOCUMENT_CREATE_SUCCESS);

/**
 * Create Sku Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const documentCreateError = simpleAction(TYPES.DOCUMENT_CREATE_FAIL);

/**
 * Create Sku Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const documentCreateDone = simpleAction(TYPES.DOCUMENT_CREATE_DONE);

/**
 * Create Sku
 * @type {function(type: string): {type: string, payload: any}}
 */
export const documentDestroyRequest = simpleAction(TYPES.DOCUMENT_DESTROY_REQUEST);

/**
 * Destroy Sku Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const documentDestroySuccess = simpleAction(TYPES.DOCUMENT_DESTROY_SUCCESS);

/**
 * Destroy Sku Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const documentDestroyError = simpleAction(TYPES.DOCUMENT_DESTROY_FAIL);

/**
 * Destroy Sku Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const documentDestroyDone = simpleAction(TYPES.DOCUMENT_DESTROY_DONE);
